function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Button, Divider, HStack, Heading, Icon, IconButton, Modal as ChakraModal, ModalBody, ModalContent, ModalOverlay, Stack, Text, PinInput, PinInputField, Center, Input, Box } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faClose, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, useIntl } from 'react-intl';
var BACKUP_CODE_REGEX = /^[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}$/;
export function TwoFactorRequired(param) {
    var description = param.description, heading = param.heading, _param_showBackupCodeInput = param.showBackupCodeInput, showBackupCodeInput = _param_showBackupCodeInput === void 0 ? true : _param_showBackupCodeInput, onClose = param.onClose, onComplete = param.onComplete;
    var intl = useIntl();
    var backupCodeInputRef = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(), 2), error = _React_useState1[0], setError = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(''), 2), value = _React_useState2[0], setValue = _React_useState2[1];
    var firstCharacter = React.useMemo(function() {
        var _value_;
        return (_value_ = value[0]) !== null && _value_ !== void 0 ? _value_ : '';
    }, [
        value
    ]);
    var _React_useState3 = _sliced_to_array(React.useState(false), 2), isFirstInputFocused = _React_useState3[0], setIsFirstInputFocused = _React_useState3[1];
    var _React_useState4 = _sliced_to_array(React.useState(false), 2), isEnteringBackupCode = _React_useState4[0], setIsEnteringBackupCode = _React_useState4[1];
    var handleComplete = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(value) {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (loading || value.length === 0) {
                            return [
                                2
                            ];
                        }
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            onComplete(value)
                        ];
                    case 2:
                        _state.sent();
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (_instanceof(error, Error)) {
                            setError(error.message);
                        } else {
                            setError('An unknown error occurred.');
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        loading,
        onClose,
        onComplete
    ]);
    React.useEffect(function() {
        setValue('');
        var input = backupCodeInputRef.current;
        if (input == null) {
            return;
        }
        input.focus();
    }, [
        isEnteringBackupCode
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(HStack, {
                justifyContent: "space-between",
                alignItems: "center",
                px: 6,
                py: 4,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "md",
                        children: heading
                    }),
                    onClose != null ? /*#__PURE__*/ _jsx(IconButton, {
                        variant: "ghost",
                        size: "sm",
                        "aria-label": intl.formatMessage({
                            id: "rbrahO",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Close"
                                }
                            ]
                        }),
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: faClose
                        }),
                        onClick: onClose
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 4,
                p: 6,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: description
                    }),
                    !isEnteringBackupCode ? /*#__PURE__*/ _jsx(Center, {
                        children: /*#__PURE__*/ _jsx(HStack, {
                            position: "relative",
                            children: /*#__PURE__*/ _jsxs(PinInput, {
                                otp: true,
                                onComplete: handleComplete,
                                value: value,
                                variant: "filled",
                                colorScheme: "primary",
                                onChange: setValue,
                                autoFocus: true,
                                children: [
                                    /*#__PURE__*/ _jsx(PinInputField, {
                                        zIndex: 2,
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        textAlign: "left",
                                        placeholder: "○",
                                        border: "unset",
                                        backgroundColor: "unset",
                                        textIndent: "calc(20px - ".concat(firstCharacter.length * 0.5, "ch)"),
                                        onFocus: function() {
                                            return setIsFirstInputFocused(true);
                                        },
                                        onBlur: function() {
                                            return setIsFirstInputFocused(false);
                                        },
                                        _hover: {
                                            backgroundColor: 'transparent'
                                        },
                                        _focus: {
                                            boxShadow: 'none'
                                        },
                                        _placeholder: {
                                            width: '40px',
                                            textAlign: 'center',
                                            textIndent: '0px'
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Box, {
                                        zIndex: 1,
                                        boxShadow: isFirstInputFocused ? 'outline' : 'none',
                                        backgroundColor: isFirstInputFocused ? 'backgroundSecondary' : undefined
                                    }),
                                    new Array(5).fill(null).map(function(_, i) {
                                        return /*#__PURE__*/ _jsx(PinInputField, {
                                            zIndex: 3,
                                            _focus: {
                                                boxShadow: 'outline',
                                                borderColor: 'borderSecondary'
                                            }
                                        }, "pin-input-".concat(i));
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ _jsx(Input, {
                        ref: backupCodeInputRef,
                        placeholder: "FFFF-FFFF-FFFF",
                        value: value,
                        onChange: function(e) {
                            return setValue(e.target.value);
                        },
                        isDisabled: loading,
                        _placeholder: {
                            textAlign: 'center'
                        }
                    }),
                    error != null ? /*#__PURE__*/ _jsxs(HStack, {
                        color: "textError",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faWarning
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                children: error
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                spacing: 6,
                p: 6,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        variant: "cta",
                        isLoading: loading,
                        isDisabled: value.length < 6 || isEnteringBackupCode && !BACKUP_CODE_REGEX.test(value),
                        onClick: function() {
                            return handleComplete(value);
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "q5Xl0M",
                            defaultMessage: "Verify"
                        })
                    }),
                    showBackupCodeInput ? /*#__PURE__*/ _jsx(Button, {
                        height: "100%",
                        variant: "link",
                        isDisabled: loading,
                        onClick: function() {
                            return setIsEnteringBackupCode(function(isEnteringBackupCode) {
                                return !isEnteringBackupCode;
                            });
                        },
                        flex: 1,
                        size: "sm",
                        rightIcon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: faArrowRight
                        }),
                        children: isEnteringBackupCode ? intl.formatMessage({
                            id: "viLrN+",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Enter Code"
                                }
                            ]
                        }) : intl.formatMessage({
                            id: "Uw+waw",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Use Backup Code"
                                }
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
}
export default function TwoFactorRequiredModal(param) {
    var isOpen = param.isOpen, heading = param.heading, description = param.description, showBackupCodeInput = param.showBackupCodeInput, onClose = param.onClose, onComplete = param.onComplete;
    return /*#__PURE__*/ _jsxs(ChakraModal, {
        isOpen: isOpen,
        onClose: onClose,
        isCentered: true,
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsx(ModalContent, {
                bgColor: "backgroundPrimary",
                children: /*#__PURE__*/ _jsx(ModalBody, {
                    p: 0,
                    children: /*#__PURE__*/ _jsx(TwoFactorRequired, {
                        heading: heading,
                        description: description,
                        onClose: onClose,
                        onComplete: onComplete,
                        showBackupCodeInput: showBackupCodeInput
                    })
                })
            })
        ]
    });
}
